import Palette from "../../models/palette";
    
type Particle = {
    x: number,
    y: number,
    opacity: number,
    size: number,
    speed: number,
    yVel: number,
    friction: number,
    rotation: number,
    gravity: number,
    color: string
}

const r = (a: number, b: number, c: number = null ) : number => { 
    return parseFloat((Math.random() * ((a ? a : 1) - (b ? b : 0)) + (b ? b : 0)).toFixed(c ? c : 0))
};

export default class FlashLineExplosionEffect {
    private palette: Palette
    private anim: number = -1;
    private screen: HTMLCanvasElement
    private context: CanvasRenderingContext2D
    private width: number
    private  x: number
    private y: number
    private blockSize: number
    private particles: Particle[]

    /*
    * Parameters x, y and width refers to canvas position
    */
    constructor(screen: HTMLCanvasElement, x: number, y: number, width: number, palette: Palette) {
        this.screen = screen;
        this.context = screen.getContext("2d");
        this.palette = palette;
        this.blockSize = width/10;
        this.width = width;
        this.x = x;
        this.y = y;
    }

    enter(flashBlocks: number[][]): void {
        this.particles  = [];
        for (let row = 12; row < 32; row++) {
            for (let col = 4; col < 14; col++) {
                if (flashBlocks[row][col]) {
                    let color = flashBlocks[row][col] >> 4;
                    let { r, g, b } = this.palette.values[color];
                    let blockParticles = this.createBlockParticles(
                        this.x + (col - 4) * this.blockSize, 
                        this.y + (row - 12) * this.blockSize, 
                        `rgba(${r},${g},${b},0.8)`
                    );
                    this.particles = [...this.particles, ...blockParticles];
                }
            }
        }
    }

    draw(flashAnim: number): HTMLCanvasElement {
        this.clear();
        this.drawParticle(this.particles, flashAnim);
        return this.screen
    }
    
    private createBlockParticles(x: number, y: number, color: string): Particle[] {
        let particles: Particle[] = [],
            columns = 3,
            count = Math.pow(columns,2),
            size = this.blockSize / columns;

        for(let i=0; i<count; i++){
            particles = [...particles, {
                x: x + size * (i % columns), 
                y: y + size * Math.floor(i / columns), 
                size: r(size-1, size+1), // random
                rotation: r(0, 360, 1), // random
                speed: r(1, 5), // random
                opacity: r(0, 0.5, 1), // random
                color: color,
                friction: 0.9,
                yVel: 0,
                gravity: 0.6
            }];
        }
        return particles;
    }

    private drawParticle(particles: Particle[], anim: number) {
        anim = anim/10
        particles.forEach((p, i) => {
            p.x += p.speed * anim * Math.cos(p.rotation * Math.PI / 180);
            p.y += p.speed * anim * Math.sin(p.rotation * Math.PI / 180);
            p.opacity -= 0.01;
            p.speed *= Math.pow(p.friction, anim);
            p.size *= Math.pow(p.friction, anim);
            p.yVel += p.gravity * anim;
            p.y += p.yVel * anim;
            this.context.globalAlpha = p.opacity;
            this.context.fillStyle = p.color;
            this.context.fillRect(p.x, p.y, p.size, p.size);
        });
    }

    private clear(){
        this.context.clearRect(0, 0, this.screen.width, this.screen.height);
    }
}